const DefaultHeaderRightCommon = () => {
	return (
		<>
		</>
	);
};

export default DefaultHeaderRightCommon;
